export const CATEGORIES_COLLECTION = "categories";
export const QUESTIONS_COLLECTION = "questions";
export const ANSWERS_COLLECTION = "answers";
export const LEADERBOARD_COLLECTION = "leaderboard";
export const CONTACT_COLLECTION = "contacts";
export const ORDER = "order";
export const POINTS = "points";
